import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    activeKey: {},
    routerLink: {},
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!

  return (_openBlock(), _createBlock(_component_a_menu_item, { key: _ctx.activeKey }, {
    icon: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_router_link, { to: _ctx.routerLink }, null, 8, ["to"]),
      _createVNode(_component_a_space, { "direction:vertical": "" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})